import { render, staticRenderFns } from "./slider.vue?vue&type=template&id=ecda28a2&scoped=true"
import script from "./slider.ts?vue&type=script&lang=ts&external"
export * from "./slider.ts?vue&type=script&lang=ts&external"
import style0 from "./slider.less?vue&type=style&index=0&id=ecda28a2&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecda28a2",
  null
  
)

export default component.exports